<script setup lang="ts">
import { useConfirm, useToast } from 'primevue'
import { Common, confirmMessage, confirmIcon } from './modules/common'
import AlertDialog from './components/AlertDialog.vue'
import LoadingDialog from './components/LoadingDialog.vue'
import { useSiteStore } from './stores/site'
import { computed, onMounted, provide, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const toast = useToast()
const confirm = useConfirm()
const siteStore = useSiteStore()
const { locale, t } = useI18n()

const menuLabel = computed(() => {
  if (!siteStore.currentMenu) {
    return null
  }

  return common.isKorean() ? siteStore.currentMenu.label : (siteStore.currentMenu?.labelEng ?? siteStore.currentMenu.label)
})

provide('menuLabel', menuLabel)
document.title = t('site.title')
watch(locale, () => {
  document.title = t('site.title')
})

globalThis.common = new Common(toast, confirm, [
  {
    breakpoint: '1300px',
    numVisible: 4
  },
  {
    breakpoint: '575px',
    numVisible: 1
  }
])

onMounted(() => {
  initOptions.toasts.forEach((toastOption) => {
    common.toast(toastOption)
  })
})
</script>

<template>
  <RouterView />

  <Toast position="top-right" />
  <ConfirmDialog class="mx-3 lg:mx-0">
    <template #message>
      <span :class="`${confirmIcon} p-confirmdialog-icon`"></span>
      <span class="font-medium text-xl" v-html="confirmMessage" />
    </template>
  </ConfirmDialog>
  <ConfirmDialog class="mx-3 lg:mx-0" group="dismissible" dismissable-mask>
    <template #message>
      <span :class="`${confirmIcon} p-confirmdialog-icon`"></span>
      <span class="font-medium text-xl" v-html="confirmMessage" />
    </template>
  </ConfirmDialog>
  <ConfirmPopup class="mx-3 lg:mx-0" group="popup" />
  <AlertDialog />
  <LoadingDialog />

  <div id="progress">
    <ProgressBar mode="indeterminate" style="height: 6px"></ProgressBar>
  </div>
</template>

<style>
/* Custom styling for Toast positioning */
.p-toast.p-toast-top-right {
  @apply !top-20 !right-6 max-sm:!right-2;
}

.p-toast .p-toast-message-icon {
  @apply max-sm:hidden;
}
</style>
